import { Box, Typography, Avatar, Button } from '@mui/material';
import { ArrowLeftIcon } from 'lucide-react';
import type { SimpleAccount } from '@/lib/types';

interface AccountHeaderProps {
  account: SimpleAccount;
  onBack: () => void;
}

export function AccountHeader({ account, onBack }: AccountHeaderProps) {
  return (
    <Box sx={{ mb: 4 }}>
      <Button startIcon={<ArrowLeftIcon />} onClick={onBack} sx={{ mb: 2 }}>
        アカウント一覧に戻る
      </Button>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
        <Avatar
          sx={{
            width: 64,
            height: 64,
            bgcolor: 'primary.main',
            mr: 2,
          }}
        >
          {account.name.charAt(0)}
        </Avatar>
        <Box>
          <Typography variant="h4" component="h1">
            {account.name}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            アカウントID: {account.id} • コード: {account.code}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
